<a
  #idpLink
  [id]="id"
  (click)="notify()"
  [attr.aria-haspopup]="ariaPopup"
  [ngClass]="getClasses()"
  class="link"
  [href]="actionUrl ? actionUrl : ('javascript:void(0)' | trustContent : 'url')"
  [target]="actionUrl ? '_blank' : '_self'"
>
  <span class="title-container">
    <span class="sr-only">
      {{ axLabel }}
    </span>
    <span
      *ngIf="label"
      [innerHTML]="label"
      [attr.aria-hidden]="ariaHidden"
      data-test-link-title="true"
    ></span>
    <span class="sr-only">
      {{ axTitle }}
    </span>
  </span>
  <span *ngIf="!image.show" class="sr-only">{{ index }}</span>
  <img *ngIf="image.show" alt="{{ index }}" src="{{ image.src }}" />
  <span *ngIf="arrow" class="link-arrow" aria-hidden="true"></span>
</a>
